import React from "react";
import Header from "../../Components/Header";
import Card from "../../Components/Card";
import Image from "../../Assets/Images/Breakers/ABB Breakers.jpg";
import Image1 from "../../Assets/Images/Breakers/Abb Circuit Breaker.jpg";
import Image2 from "../../Assets/Images/Breakers/Clipsal Breakers.png";
import Image3 from "../../Assets/Images/Breakers/LS Breakers.jpg";
import Image4 from "../../Assets/Images/Breakers/sch.jpg";
import Image5 from "../../Assets/Images/Breakers/Terasaki Breaker.jpg";
import Category from "../../Components/Category";
import CategoryHeading from "../../Components/CategoryHeading";
import Footer from "../../Components/Footer/indes";
import "./Product.css";

function Product() {
  return (
    <>
      <div style={{ height: 80 }}>
        <Header />
      </div>

      <Category />
      <CategoryHeading Title={"Our Breakers"} />

      <div className="my-cards">
        <Card Image={Image} Title={"ABB Breakers"} />
        <Card Image={Image1} Title={"ABB Circuit Breaker"} />
        <Card Image={Image2} Title={"Clipsal Breaker"} />
        <Card Image={Image3} Title={"LS Breakers"} />
        <Card Image={Image4} Title={"Schneider Breakers"} />
        <Card Image={Image5} Title={"Terasaki Breaker"} />
      </div>
      <Footer />
    </>
  );
}

export default Product;
